import type { PageConfig } from "../types";

export const page: PageConfig = {
  title: "CME Feedback",
  description:
    "Review a slow-trend detection's feature graph and record whether it was useful, with a comment.",
  icon: "message",
  order: 40,
};
